import { render, staticRenderFns } from "./NotesContainer.vue?vue&type=template&id=607fc0d2&scoped=true&"
import script from "./NotesContainer.vue?vue&type=script&lang=js&"
export * from "./NotesContainer.vue?vue&type=script&lang=js&"
import style0 from "./NotesContainer.vue?vue&type=style&index=0&id=607fc0d2&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "607fc0d2",
  null
  
)

export default component.exports